import { useState } from "react";
import { useSelector } from "react-redux";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Footer from "../../components/Footer";
import { api } from "../../axios/api";
import { Calendar, FileDown, RefreshCw, AlertCircle } from "lucide-react";

const GerarSaft = () => {
    const user = useSelector((state) => state.user.user);
    const empresaId = user?.empresa_id;

    const hojeStr = new Date().toISOString().split('T')[0];
    const [dataInicio, setDataInicio] = useState(hojeStr);
    const [dataFim, setDataFim] = useState(hojeStr);
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        setLoading(true);
        try {
            // Chamada à rota: /saft/generate/empresa/:empresa_id/start/:start_date/end/:end_date
            const response = await api.post(`/app/saft/generate/empresa/${empresaId}/start/${dataInicio}/end/${dataFim}`, {
                responseType: 'blob'
            });

            // Criação do link para download do XML
            const blob = new Blob([response.data], { type: 'application/xml' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `SAF-T_AO_${empresaId}_${dataInicio}_${dataFim}.xml`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erro ao gerar SAF-T:", error);
            alert("Erro ao gerar o ficheiro SAF-T. Verifique as datas ou tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="layout-wrapper">
            <Navbar />
            <Sidebar />
            <main className="app-wrapper">
                <div className="win10-layout">
                    <div className="win10-card-main">
                        <div className="mb-4">
                            <h2 className="win10-panel-title">Exportação SAF-T AO</h2>
                            <p className="text-muted small">Gere o ficheiro de exportação de dados contabilísticos para a AGT.</p>
                        </div>

                        <div className="d-flex gap-3 align-items-end mb-4 pb-3 border-bottom">
                            <div className="d-flex flex-column">
                                <label className="text-muted small fw-bold mb-1">Data de Início</label>
                                <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} className="win10-input" />
                            </div>
                            <div className="d-flex flex-column">
                                <label className="text-muted small fw-bold mb-1">Data de Fim</label>
                                <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} className="win10-input" />
                            </div>
                            
                            <button className="win10-btn-filter" onClick={handleDownload} disabled={loading}>
                                {loading ? <RefreshCw className="animate-spin" size={14} /> : <FileDown size={14} />} 
                                {loading ? "Processando..." : "Descarregar SAF-T"}
                            </button>
                        </div>

                        <div className="alert alert-info d-flex align-items-center gap-3" style={{ fontSize: '13px', border: 'none', background: '#f0f7ff', color: '#005a9e' }}>
                            <AlertCircle size={32} />
                            <div>
                                <strong>Nota de Exportação:</strong><br/>
                                O ficheiro SAF-T contém a estrutura obrigatória definida pela AGT. Certifique-se de selecionar o intervalo de datas correto correspondente ao período fiscal pretendido.
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
            
            <style>{`
                .win10-layout { padding: 20px; }
                .win10-card-main { background: #fff; padding: 25px; border: 1px solid #e1e1e1; }
                .win10-panel-title { font-size: 18px; color: #323130; font-weight: 600; text-transform: uppercase; }
                .win10-input { height: 34px; padding: 5px 10px; border: 1px solid #8a8886; width: 160px; }
                .win10-btn-filter { background: #323130; color: #fff; border: none; height: 34px; padding: 0 20px; display: flex; align-items: center; gap: 8px; cursor: pointer; text-transform: uppercase; font-size: 12px; font-weight: 600; }
                .win10-btn-filter:hover { background: #000; }
                .win10-btn-filter:disabled { background: #ccc; cursor: not-allowed; }
            `}</style>
        </div>
    );
};

export default GerarSaft;